export default __webpack_public_path__ + "static/media/results_icon.ec6de441.png";